var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-wrap"},[_c('div',{staticClass:"logo dib",on:{"click":() => this.$router.replace('/')}},[_c('span',{staticClass:"iconfont iconlogo"})]),_c('h1',{staticClass:"dib logo_text"},[_vm._v("食品标签在线服务领导品牌")])])
}
var staticRenderFns = []

export { render, staticRenderFns }